import bg from '../../assets/stage.webp';
import React from 'react';
import firstIcon from '../../assets/daily-first.png';
import thirdIcon from '../../assets/daily-thrid.webp';
import secondIcon from '../../assets/daily-second.webp';
import priceIcon from '../../assets/daily-price.webp';
import bounsIcon from '../../assets/daily-bouns.webp';
import defaultUser from '@/common-pages/leaderboard/assets/user-default-2.svg';
import {Image} from 'antd-mobile';
import {LeaderboardItemType} from '../../types';
import {toPriceStr} from '@components/utils';

interface StageProps {
  topThree: LeaderboardItemType[];
  loading?: boolean;
}

const formatUsername = (username: string) => {
  // 隐藏中间部分，只显示前2位和后3位
  if (!username || username === '---') return '---';
  if (username.length <= 5) return username;
  return `${username.slice(0, 2)}***${username.slice(-3)}`;
};

export default function Stage({topThree = []}: StageProps) {
  // 默认用户数据，当没有数据时使用
  const defaultUsers: LeaderboardItemType[] = [
    {
      id: 'default-1',
      username: '---',
      userPhone: '',
      rank: 1,
      bonus: 0,
      point: 0,
      avatar: '',
      rewardRate: 0,
      rewardRateStr: '',
    },
    {
      id: 'default-2',
      username: '---',
      userPhone: '',
      rank: 2,
      bonus: 0,
      point: 0,
      avatar: '',
      rewardRate: 0,
      rewardRateStr: '',
    },
    {
      id: 'default-3',
      username: '---',
      userPhone: '',
      rank: 3,
      bonus: 0,
      point: 0,
      avatar: '',
      rewardRate: 0,
      rewardRateStr: '',
    },
  ];

  const users = topThree.length >= 3 ? topThree : defaultUsers;

  return (
    <div className="relative h-[11.5rem] w-full pointer-events-none">
      <div
        className="bg-full h-[15.75rem] absolute w-full"
        style={{backgroundImage: `url(${bg})`}}>
        {/* 第1名 - 大尺寸 */}
        <div
          className="absolute left-[9.0625rem] top-0"
          style={{width: '5.875rem'}}>
          <div className="w-[5.875rem] h-[5.875rem] bg-full flex justify-center items-center relative">
            <div className="w-[3.675rem] h-[3.675rem] rounded-full overflow-hidden relative">
              <div
                className="size-full  bg-full"
                style={{
                  backgroundImage: `url(${users[0].avatar || defaultUser})`,
                }}></div>
            </div>
            <div
              className="w-[5.875rem] h-[5.875rem] bg-full absolute"
              style={{
                backgroundImage: `url(${firstIcon})`,
              }}></div>
          </div>

          <div className="flex justify-center items-center">
            <div className="px-1.5 text-[0.5625rem] font-medium text-white rounded-full w-[4.125rem] h-[0.9375rem] text-center border-[0.03125rem] border-[#ffb937] bg-gradient-to-b from-[#412006] to-[#93580A]">
              {formatUsername(users[0].username)}
            </div>
          </div>

          <div className="flex flex-col justify-center items-center">
            <div className="flex items-center gap-0.5">
              <Image className="w-[0.6875rem] h-[0.5625rem]" src={priceIcon} />
              <div className="text-white text-[0.625rem] font-bold">
                {toPriceStr(users[0].bonus || 0, {
                  showCurrency: false,
                  suffixUnit: 'K',
                  fixed: 2,
                })}
              </div>
            </div>

            <div
              className="flex gap-0.5 mt-0.5"
              style={{
                textShadow: `
                  -1px -1px 0 #774B02,
                  1px -1px 0 #774B02,
                  -1px 1px 0 #774B02,
                  1px 1px 0 #774B02
                `,
              }}>
              <Image className="size-2.5" src={bounsIcon} />
              <div className="text-[#FFE9AB] text-[0.5625rem] font-bold">
                {toPriceStr(users[0].point || 0, {
                  showCurrency: false,
                  suffixUnit: 'K',
                  fixed: 0,
                })}
              </div>
            </div>

            {users[0].rewardRate ? (
              <div
                className="text-[#FFE9AB] text-[0.5625rem] font-bold text-center"
                style={{
                  textShadow: `
                    -1px -1px 0 #774B02,
                    1px -1px 0 #774B02,
                    -1px 1px 0 #774B02,
                    1px 1px 0 #774B02
                  `,
                }}>
                ({users[0].rewardRateStr})
              </div>
            ) : null}
          </div>
        </div>

        {/* 第2名 - 标准尺寸 */}
        <div
          className="absolute left-[2.525rem] top-5"
          style={{width: '5.375rem'}}>
          <div className="w-[5.375rem] h-[5.375rem] bg-full flex justify-center items-center">
            <div className="w-[3.375rem] h-[3.375rem] rounded-full overflow-hidden relative">
              <div
                className="size-full  bg-full"
                style={{
                  backgroundImage: `url(${users[1].avatar || defaultUser})`,
                }}></div>
            </div>
            <div
              className="w-[5.375rem] h-[5.375rem] bg-full absolute"
              style={{
                backgroundImage: `url(${secondIcon})`,
              }}></div>
          </div>

          <div className="flex justify-center items-center">
            <div className="px-1.5 text-[0.5625rem] font-medium text-white rounded-full w-[4.125rem] h-[0.9375rem] text-center border-[0.03125rem] border-[#C3CFE4] bg-[#5C658E]">
              {formatUsername(users[1].username)}
            </div>
          </div>

          <div className="flex flex-col justify-center items-center">
            <div className="flex items-center gap-0.5">
              <Image className="w-[0.6875rem] h-[0.5625rem]" src={priceIcon} />
              <div className="text-white text-[0.625rem] font-bold">
                {toPriceStr(users[1].bonus || 0, {
                  showCurrency: false,
                  suffixUnit: 'K',
                  fixed: 2,
                })}
              </div>
            </div>

            <div
              className="flex gap-0.5 mt-0.5"
              style={{
                textShadow: `
                  -1px -1px 0 #20315C,
                  1px -1px 0 #20315C,
                  -1px 1px 0 #20315C,
                  1px 1px 0 #20315C
                `,
              }}>
              <Image className="size-2.5" src={bounsIcon} />
              <div className="text-[#D1E5F9] text-[0.5625rem] font-bold">
                {toPriceStr(users[1].point || 0, {
                  showCurrency: false,
                  suffixUnit: 'K',
                  fixed: 0,
                })}
              </div>
            </div>

            {users[1].rewardRate ? (
              <div
                className="text-[#D1E5F9] text-[0.5625rem] font-bold text-center"
                style={{
                  textShadow: `
                    -1px -1px 0 #20315C,
                    1px -1px 0 #20315C,
                    -1px 1px 0 #20315C,
                    1px 1px 0 #20315C
                  `,
                }}>
                ({users[1].rewardRateStr})
              </div>
            ) : null}
          </div>
        </div>

        {/* 第3名 - 标准尺寸 */}
        <div
          className="absolute left-[15.925rem] top-5"
          style={{width: '5.375rem'}}>
          <div
            className="w-[5.375rem] h-[5.375rem] bg-full flex justify-center items-center"
            style={{
              backgroundImage: `url(${thirdIcon})`,
            }}>
            <div className="w-[3.375rem] h-[3.375rem] rounded-full overflow-hidden relative">
              <div
                className="size-full  bg-full"
                style={{
                  backgroundImage: `url(${users[2].avatar || defaultUser})`,
                }}></div>
            </div>
            <div
              className="w-[5.375rem] h-[5.375rem] bg-full absolute"
              style={{
                backgroundImage: `url(${thirdIcon})`,
              }}></div>
          </div>

          <div className="flex justify-center items-center">
            <div className="px-1.5 text-[0.5625rem] font-medium text-white rounded-full w-[4.125rem] h-[0.9375rem] text-center border-[0.03125rem] border-[#FF8E81] bg-[#81382D]">
              {formatUsername(users[2].username)}
            </div>
          </div>

          <div className="flex flex-col justify-center items-center">
            <div className="flex items-center gap-0.5">
              <Image className="w-[0.6875rem] h-[0.5625rem]" src={priceIcon} />
              <div className="text-white text-[0.625rem] font-bold">
                {toPriceStr(users[2].bonus || 0, {
                  showCurrency: false,
                  suffixUnit: 'K',
                  fixed: 2,
                })}
              </div>
            </div>

            <div
              className="flex gap-0.5 mt-0.5"
              style={{
                textShadow: `
                  -1px -1px 0 #74230D,
                  1px -1px 0 #74230D,
                  -1px 1px 0 #74230D,
                  1px 1px 0 #74230D
                `,
              }}>
              <Image className="size-2.5" src={bounsIcon} />
              <div className="text-[#FCC3A3] text-[0.5625rem] font-bold">
                {toPriceStr(users[2].point || 0, {
                  showCurrency: false,
                  suffixUnit: 'K',
                  fixed: 0,
                })}
              </div>
            </div>

            {users[2].rewardRate ? (
              <div
                className="text-[#FCC3A3] text-[0.5625rem] font-bold text-center"
                style={{
                  textShadow: `
                    -1px -1px 0 #74230D,
                    1px -1px 0 #74230D,
                    -1px 1px 0 #74230D,
                    1px 1px 0 #74230D
                  `,
                }}>
                ({users[2].rewardRateStr})
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
